import React, { useEffect } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css"; 
import image from "../../assets/images/party.png"; 
import { useNavigate } from "react-router-dom";

const NadPlusThankYouPage = () => {
    const navigate = useNavigate();
    const location = window.location.pathname;
    const isSermorelinPage = location.includes("sermorelin");
     useEffect(() => {
        const success = JSON.parse(localStorage.getItem("success_transaction") || "{}")?.value;
    
        if (success === true) {
          window.history.pushState(null, "", window.location.href);
    
          const handleBack = () => {
            localStorage.removeItem("completed-step-1");
            localStorage.removeItem("completed-step-2");
            localStorage.removeItem("completed-step-3");
            localStorage.removeItem("completed-step-4");
            localStorage.removeItem("completed-step-5");
            localStorage.removeItem("completed-step-6");
            localStorage.removeItem("completed-step-7");
            localStorage.removeItem("completed-step-8");
            localStorage.removeItem("completed-step-9");
            localStorage.removeItem("completed-step-10");
            localStorage.removeItem("completed-step-11");
            localStorage.removeItem("completed-step-12");
            localStorage.removeItem("completed-step-13");
            localStorage.removeItem("completed-step-14");
            if(isSermorelinPage){
              navigate("/sermorelin", { replace: true });
            }else{
            navigate("/nadplus", { replace: true }); // Redirect to home instead of doing nothing
            }
          };
    
          window.addEventListener("popstate", handleBack);
    
          return () => {
            window.removeEventListener("popstate", handleBack);
          };
        }
      }, [navigate]);
      // useEffect(() => {
      //   const timer = setTimeout(() => {
      //     localStorage.clear();
      //     if(isSermorelinPage){
      //       navigate("/sermorelin")
      //     }else{
      //     navigate("/nadplus")
      //     }
      //   }, 5000);
      //   return () => clearTimeout(timer);
      // }, []);
    
      useEffect(() => {
        const step13Completed = localStorage.getItem("completed-step-13");
        const step14Completed = localStorage.getItem("completed-step-14")
        if(isSermorelinPage){
          if(step14Completed)
          navigate("/sermorelin/thank-you")
        }else{
          if (step13Completed) {
            navigate("/nadplus/thank-you")
        }
        }
        
      }, []);
  return (
    <PageWrapper>
      <div className="signup-page-container" style={{marginTop: "-60px"}}>
        <div className="thank-you-page-container">
          <div className="thank-you-image-container">
            <img src={image} alt="Thank You" className="thank-you-image" />
          </div>
          <p className="thank-you-heading">
            Thank you for your purchase.
          </p>
          <p className="thank-you-description" style={{lineHeight: "normal"}}>
            Please check your inbox for updates about next steps and delivery.
          </p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusThankYouPage;